import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const adminUser = localStorage.getItem("adminUser");

  if (!adminUser) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;